/* eslint-disable react/no-danger */
/* eslint-disable no-cond-assign */
import React, { PureComponent } from 'react';
import { func, string as str, bool, any, shape } from 'prop-types';
import _debounce from 'lodash/debounce';

import { secondaryMain } from 'crehana-ui/styles/colors';

import getMediaUrl from 'Jsx/Utils/getMediaUrl';
import { getString } from 'Utils/randomizer';
import dispatchEvent from 'Utils/dispatchEvent';

import LinkPreview from './ui/LinkPreview';
import Image from './ui/Image';
import unescapeChars from './unescapeChars';
import {
  REGEX_EMAIL,
  REGEX_URL,
  REGEX_URL_BEGIN,
  REGEX_FILE,
  REGEX_TAG,
  REGEX_TAG_ALONE,
  REGEX_SPAN,
  REGEX_A,
  REGEX_IMG,
  REGEX_MEDIA,
  REGEX_BOLD,
  REGEX_ITALIC,
  REGEX_UNDERLINE,
  REGEX_BI,
  REGEX_BU,
  REGEX_IU,
  REGEX_BIU,
  REGEX_BR,
} from './regex';

// we need to create this function outside the component to make _debounce to work
// We are using debounce because we don't want to dispatch a event for each link,
// we want to dispatch the event only for the last link parsed.
const dispatchEventForLinkPreview = _debounce(() => {
  dispatchEvent({
    target: document,
    detail: {},
    type: 'onLinkPreview',
  });
}, 1000);

class StringParser extends PureComponent {
  state = {
    url: undefined,
  };

  parseString = () => {
    const {
      string: stringProp,
      breaks,
      emails,
      tags,
      img,
      media,
      style,
      links,
    } = this.props;
    const elements = [];
    const string = unescapeChars(stringProp);

    if (breaks) {
      elements.push(this.parseBreaks(string));
    } else if (emails) {
      elements.push(this.parseEmails(string));
    } else if (tags) {
      elements.push(this.parseSpanTags(string));
    } else if (img) {
      elements.push(this.parseImg(string));
    } else if (media) {
      elements.push(this.parseMedia(string));
    } else if (style) {
      elements.push(this.parseStylesB(string));
    } else if (links) {
      elements.push(this.parseLinks(string));
    } else {
      elements.push(<span key={getString()}>{string}</span>);
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  // First, check for br tags
  parseBreaks = string => {
    const { emails, tags, img, media, style, links } = this.props;
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_BR.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        if (emails) {
          elements.push(
            this.parseEmails(string.substring(lastIndex, match.index)),
          );
        } else if (tags) {
          elements.push(
            this.parseSpanTags(string.substring(lastIndex, match.index)),
          );
        } else if (img) {
          elements.push(
            this.parseImg(string.substring(lastIndex, match.index)),
          );
        } else if (media) {
          elements.push(
            this.parseMedia(string.substring(lastIndex, match.index)),
          );
        } else if (style) {
          elements.push(
            this.parseStylesB(string.substring(lastIndex, match.index)),
          );
        } else if (links) {
          elements.push(
            this.parseLinks(string.substring(lastIndex, match.index)),
          );
        } else {
          elements.push(
            <span key={getString()}>
              {string.substring(lastIndex, match.index)}
            </span>,
          );
        }
      }
      elements.push(<br key={getString()} />);
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      if (emails) {
        elements.push(this.parseEmails(string.substring(lastIndex)));
      } else if (tags) {
        elements.push(this.parseSpanTags(string.substring(lastIndex)));
      } else if (img) {
        elements.push(this.parseImg(string.substring(lastIndex)));
      } else if (media) {
        elements.push(this.parseMedia(string.substring(lastIndex)));
      } else if (style) {
        elements.push(this.parseStylesB(string.substring(lastIndex)));
      } else if (links) {
        elements.push(this.parseLinks(string.substring(lastIndex)));
      } else {
        elements.push(
          <span key={getString()}>{string.substring(lastIndex)}</span>,
        );
      }
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  // check for email address
  parseEmails = string => {
    const { tags, img, media, style, links } = this.props;
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_EMAIL.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        if (tags) {
          elements.push(
            this.parseSpanTags(string.substring(lastIndex, match.index)),
          );
        } else if (img) {
          elements.push(
            this.parseImg(string.substring(lastIndex, match.index)),
          );
        } else if (media) {
          elements.push(
            this.parseMedia(string.substring(lastIndex, match.index)),
          );
        } else if (style) {
          elements.push(
            this.parseStylesB(string.substring(lastIndex, match.index)),
          );
        } else if (links) {
          elements.push(
            this.parseLinks(string.substring(lastIndex, match.index)),
          );
        } else {
          elements.push(
            <span key={getString()}>
              {string.substring(lastIndex, match.index)}
            </span>,
          );
        }
      }
      const text = match[0];

      elements.push(
        <a
          key={getString()}
          href={`mailto:${text}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: secondaryMain }}
        >
          {text}
        </a>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      if (tags) {
        elements.push(this.parseSpanTags(string.substring(lastIndex)));
      } else if (img) {
        elements.push(this.parseImg(string.substring(lastIndex)));
      } else if (media) {
        elements.push(this.parseMedia(string.substring(lastIndex)));
      } else if (style) {
        elements.push(this.parseStylesB(string.substring(lastIndex)));
      } else if (links) {
        elements.push(this.parseLinks(string.substring(lastIndex)));
      } else {
        elements.push(
          <span key={getString()}>{string.substring(lastIndex)}</span>,
        );
      }
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  // add link to profile when there's a <span> tag
  parseSpanTags = string => {
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_SPAN.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(this.parseTags(string.substring(lastIndex, match.index)));
      }
      const text = match[0];
      const tag = text.match(REGEX_TAG) ? text.match(REGEX_TAG)[0] : text;

      elements.push(
        <a
          key={getString()}
          href={`/users/${tag.replace(/@/, '').replace(' ', '')}`}
          target="_blank"
          style={{ color: secondaryMain }}
          // temporal fix to remove Google Indexation for inactive profile-urls
          rel="nofollow"
        >
          {tag}
        </a>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(this.parseTags(string.substring(lastIndex)));
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  // add link to profile when there's NO a <span> tag in the @username
  parseTags = string => {
    const { img, media, style, links } = this.props;
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_TAG_ALONE.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        if (img) {
          elements.push(
            this.parseImg(string.substring(lastIndex, match.index)),
          );
        } else if (media) {
          elements.push(
            this.parseMedia(string.substring(lastIndex, match.index)),
          );
        } else if (style) {
          elements.push(
            this.parseStylesB(string.substring(lastIndex, match.index)),
          );
        } else if (links) {
          elements.push(
            this.parseLinks(string.substring(lastIndex, match.index)),
          );
        } else {
          elements.push(
            <span key={getString()}>
              {string.substring(lastIndex, match.index)}
            </span>,
          );
        }
      }
      const text = match[0];

      elements.push(
        <a
          key={getString()}
          href={`/users/${text.replace(/@/, '').replace(' ', '')}`}
          target="_blank"
          style={{ color: secondaryMain }}
          // temporal fix to remove Google Indexation for inactive profile-urls
          rel="nofollow"
        >
          {text}
        </a>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      if (img) {
        elements.push(this.parseImg(string.substring(lastIndex)));
      } else if (media) {
        elements.push(this.parseMedia(string.substring(lastIndex)));
      } else if (style) {
        elements.push(this.parseStylesB(string.substring(lastIndex)));
      } else if (links) {
        elements.push(this.parseLinks(string.substring(lastIndex)));
      } else {
        elements.push(
          <span key={getString()}>{string.substring(lastIndex)}</span>,
        );
      }
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  // render img tags that are already inside an a tag
  parseImg = string => {
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_A.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(this.parseImg2(string.substring(lastIndex, match.index)));
      }
      elements.push(
        <div
          key={getString()}
          dangerouslySetInnerHTML={{ __html: match[0] }}
        />,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(this.parseImg2(string.substring(lastIndex)));
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  // render img tags
  parseImg2 = string => {
    const { media, style, links } = this.props;
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_IMG.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        if (media) {
          elements.push(
            this.parseMedia(string.substring(lastIndex, match.index)),
          );
        } else if (style) {
          elements.push(
            this.parseStylesB(string.substring(lastIndex, match.index)),
          );
        } else if (links) {
          elements.push(
            this.parseLinks(string.substring(lastIndex, match.index)),
          );
        } else {
          elements.push(
            <span key={getString()}>
              {string.substring(lastIndex, match.index)}
            </span>,
          );
        }
      }
      const text = match[0].replace(/<img/, '<img width="100%"');

      elements.push(
        <div key={getString()} dangerouslySetInnerHTML={{ __html: text }} />,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      if (media) {
        elements.push(this.parseMedia(string.substring(lastIndex)));
      } else if (style) {
        elements.push(this.parseStylesB(string.substring(lastIndex)));
      } else if (links) {
        elements.push(this.parseLinks(string.substring(lastIndex)));
      } else {
        elements.push(
          <span key={getString()}>{string.substring(lastIndex)}</span>,
        );
      }
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  // render img based on the custom [MEDIA ] format
  parseMedia = string => {
    const { media, style, links } = this.props;
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_MEDIA.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        if (style) {
          elements.push(
            this.parseStylesB(string.substring(lastIndex, match.index)),
          );
        } else if (links) {
          elements.push(
            this.parseLinks(string.substring(lastIndex, match.index)),
          );
        } else {
          elements.push(
            <span key={getString()}>
              {string.substring(lastIndex, match.index)}
            </span>,
          );
        }
      }
      let url = /url='.+?'/.exec(match[0])[0];
      let href;
      let m;

      url = getMediaUrl(url.substring(5, url.length - 1));
      if ((m = /href='.+?'/.exec(match[0])) !== null) {
        href = m[0].substring(6, m[0].length - 1);
      }
      elements.push(<Image key={getString()} src={url} href={href} />);
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      if (style) {
        elements.push(this.parseStylesB(string.substring(lastIndex)));
      } else if (links) {
        elements.push(this.parseLinks(string.substring(lastIndex)));
      } else {
        elements.push(
          <span key={getString()}>{string.substring(lastIndex)}</span>,
        );
      }
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  parseStylesB = string => {
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_BOLD.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(
          this.parseStylesI(string.substring(lastIndex, match.index)),
        );
      }
      const content = match[0].substring(2, match[0].length - 2);

      elements.push(
        <span key={getString()} style={{ fontWeight: 'bold' }}>
          {content}
        </span>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(this.parseStylesI(string.substring(lastIndex)));
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  parseStylesI = string => {
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_ITALIC.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(
          this.parseStylesU(string.substring(lastIndex, match.index)),
        );
      }
      const content = match[0].substring(2, match[0].length - 2);

      elements.push(
        <span key={getString()} style={{ fontStyle: 'italic' }}>
          {content}
        </span>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(this.parseStylesU(string.substring(lastIndex)));
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  parseStylesU = string => {
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_UNDERLINE.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(
          this.parseStylesBI(string.substring(lastIndex, match.index)),
        );
      }
      const content = match[0].substring(2, match[0].length - 2);

      elements.push(
        <span key={getString()} style={{ textDecoration: 'underline' }}>
          {content}
        </span>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(this.parseStylesBI(string.substring(lastIndex)));
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  parseStylesBI = string => {
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_BI.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(
          this.parseStylesBU(string.substring(lastIndex, match.index)),
        );
      }
      const content = match[0].substring(2, match[0].length - 2);

      elements.push(
        <span
          key={getString()}
          style={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {content}
        </span>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(this.parseStylesBU(string.substring(lastIndex)));
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  parseStylesBU = string => {
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_BU.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(
          this.parseStylesIU(string.substring(lastIndex, match.index)),
        );
      }
      const content = match[0].substring(2, match[0].length - 2);

      elements.push(
        <span
          key={getString()}
          style={{ fontWeight: 'bold', textDecoration: 'underline' }}
        >
          {content}
        </span>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(this.parseStylesIU(string.substring(lastIndex)));
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  parseStylesIU = string => {
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_IU.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(
          this.parseStylesBIU(string.substring(lastIndex, match.index)),
        );
      }
      const content = match[0].substring(2, match[0].length - 2);

      elements.push(
        <span
          key={getString()}
          style={{ fontStyle: 'italic', textDecoration: 'underline' }}
        >
          {content}
        </span>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(this.parseStylesBIU(string.substring(lastIndex)));
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  parseStylesBIU = string => {
    const { links } = this.props;
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_BIU.exec(string)) !== null) {
      // Parse the preceding text if there is any
      if (match.index > lastIndex) {
        if (links) {
          elements.push(
            this.parseLinks(string.substring(lastIndex, match.index)),
          );
        } else {
          elements.push(
            <span key={getString()}>
              {string.substring(lastIndex, match.index)}
            </span>,
          );
        }
      }
      const content = match[0].substring(2, match[0].length - 2);

      elements.push(
        <span
          key={getString()}
          style={{
            fontWeight: 'bold',
            fontStyle: 'italic',
            textDecoration: 'underline',
          }}
        >
          {content}
        </span>,
      );
      lastIndex = match.index + match[0].length;
    }
    // Parse the rest of the text if there is any
    if (lastIndex < string.length) {
      if (links) {
        elements.push(this.parseLinks(string.substring(lastIndex)));
      } else {
        elements.push(
          <span key={getString()}>{string.substring(lastIndex)}</span>,
        );
      }
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  // check for links
  parseLinks = string => {
    const { linkPreview } = this.props;
    const elements = [];

    if (string === '') return elements;
    let lastIndex = 0;
    let match;

    while ((match = REGEX_URL.exec(string)) !== null) {
      // Push the preceding text if there is any
      if (match.index > lastIndex) {
        elements.push(
          <span key={getString()}>
            {string.substring(lastIndex, match.index)}
          </span>,
        );
      }
      let text = match[0];

      if (text.match(REGEX_FILE)) {
        elements.push(text);
      } else {
        text = text
          .substring(0, 1)
          .toLowerCase()
          .concat(text.substring(1));
        const url = text.match(REGEX_URL_BEGIN) ? text : `http://${text}`;

        if (text.length > 30) {
          text = url.replace(REGEX_URL_BEGIN, '');
          if (text.length > 30) {
            text = text.substring(0, 30).concat('...');
          }
        }
        elements.push(
          <a
            key={getString()}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: secondaryMain, wordBreak: 'break-all' }}
          >
            {text}
          </a>,
        );
        // Check if another url was already saved (show preview only for first link provided)
        if (linkPreview && !this.state.url) {
          this.setState({ url }, () => {
            if (this.props.shouldDispatchEventForLinkPreview) {
              dispatchEventForLinkPreview();
            }
          });
        }
        lastIndex = match.index + match[0].length;
      }
    }
    // Push the rest of the text if there is any
    if (lastIndex < string.length) {
      elements.push(
        <span key={getString()}>{string.substring(lastIndex)}</span>,
      );
    }
    return elements.length === 1 ? elements[0] : elements;
  };

  render() {
    const {
      children,
      string,
      breaks,
      emails,
      tags,
      img,
      media,
      style,
      links,
      linkPreview,
      Wrapper,
      wrapperProps,
      dark,
      linkPreviewClassName,
      linkPreviewProps,
      shouldDispatchEventForLinkPreview,
      ...other
    } = this.props;
    const { url } = this.state;

    if (typeof children === 'function') {
      return children({
        string: this.parseString(),
        preview: url ? (
          <LinkPreview
            className={linkPreviewClassName}
            url={url}
            dark={dark}
            {...linkPreviewProps}
          />
        ) : (
          undefined
        ),
      });
    }
    if (url) {
      return (
        <div {...other}>
          <Wrapper {...wrapperProps}>{this.parseString()}</Wrapper>
          <LinkPreview
            className={linkPreviewClassName}
            url={url}
            dark={dark}
            {...linkPreviewProps}
          />
        </div>
      );
    }
    return (
      <Wrapper {...wrapperProps} {...other}>
        {this.parseString()}
      </Wrapper>
    );
  }
}

StringParser.propTypes = {
  children: func,
  string: str.isRequired,
  // Parse <br> tags
  breaks: bool,
  // Parse emails
  emails: bool,
  // Parse @username tags
  tags: bool,
  // parse img tags
  img: bool,
  // parse custom [MEDIA ] using MEDIA_URL
  media: bool,
  // parse bold, italic or underline styles
  style: bool,
  // parse links
  links: bool,
  // show a link preview, only works if 'links' is also true
  linkPreview: bool,
  // Wrapper for the parsed string. Only used when children is not a function
  Wrapper: any, // eslint-disable-line react/forbid-prop-types
  // Properties applied to the string wrapper
  wrapperProps: shape({}),
  // for dark backgrounds, useful to change link preview styles
  dark: bool,
  // dispatch a debounced event when StringParser has finished to parsed the links and it is going to show the link-preview
  shouldDispatchEventForLinkPreview: bool,
  // className for the internal link preview
  linkPreviewClassName: str,
  linkPreviewProps: any, // eslint-disable-line react/forbid-prop-types
};

StringParser.defaultProps = {
  children: undefined,
  breaks: false,
  emails: false,
  tags: false,
  img: false,
  media: undefined,
  style: false,
  links: false,
  linkPreview: false,
  Wrapper: 'div',
  wrapperProps: {},
  dark: false,
  shouldDispatchEventForLinkPreview: false,
  linkPreviewClassName: '',
  linkPreviewProps: {},
};

export default StringParser;
